(ns assemble.assets-page.upload-modal.fonts
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/DialogActions$default" :as DialogActions]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            [assemble.assets-page.upload-modal.db]
            [assemble.component.dropzone :refer [dropzone-container]]
            [assemble.component.upload-modal :as upload-modal]
            [assemble.util :as util]
            [common.util :refer [spread-obj]]
            [common.widgets.form-field :refer [form-field]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def existing-font-message "The font with this extension, font weight, and style already exists in the font family.")

(defn render-edit
  "Selectbox for font weight or style"
  [options ^js params]
  ($ Select
     {:sx #js {:width "100%"}
      :MenuProps {;; Keep the backdrop so clicking outside of select closes the menu,
                  ;; but make it invisible.
                  :sx {".MuiBackdrop-root" {:backgroundColor "rgba(255, 255, 255, 0)"}}}
      ;; "" doesn't work to select option, so map empty string to "empty" value
      :value (if (= "" (.-value params))
               "empty"
               (.-value params))
      :onChange (fn [e]
                  (let [new-value (.. e -target -value)
                        new-value (if (= "empty" new-value)
                                    ""
                                    new-value)]
                    (rf/dispatch [:assemble.resource.asset/set-metadata-field
                                  (:id (.-row params))
                                  (keyword (.-field params))
                                  new-value])))}
     (for [[value label] options
           :let [value (if (= "" value)
                         "empty"
                         value)]]
       ($ MenuItem
          {:key value
           :value value}
          label))
     (when (not (contains? options (.-value params)))
       ($ MenuItem
          {:key (.-value params)
           :value (.-value params)
           :disabled true}
          "Unknown: " (.-value params)))))

(def font-queued? #{"queue"})

(def weight-or-status-column
  #js {:field "font-weight"
       :headerName "Weight"
       :valueGetter (fn [_value row ^js _column ^js _apiRef] (:font-weight (:metadata row)))
       :valueFormatter (fn [value _row ^js _column ^js _apiRef] (get util/font-weights value))
       :sortable false
       :minWidth 80
       :flex 1
       :renderCell (fn [^js o]
                     (if (font-queued? (:status (.-row o)))
                       (render-edit util/font-weights o)
                       (upload-modal/render-cell-upload-status #js {:value (:status (.-row o))
                                                                    :row (.-row o)}
                                                               {:error-messages {:duplicate-font existing-font-message}})))
       :colSpan (fn [_value row ^js _column ^js _apiRef]
                  (if (font-queued? (:status row))
                    1
                    2))})

(def style-column
  #js {:field "font-style"
       :headerName "Style"
       :valueGetter (fn [_value row ^js _column ^js _apiRef] (:font-style (:metadata row)))
       :sortable false
       :minWidth 80
       :flex 1
       ;; Editable grid requires double click on cell to make it editable,
       ;; in this case we want to make the fields editable always.
       ;; So this is just not using grid edit feature, and rendering editable
       ;; components directly.
       :renderCell (partial render-edit util/font-styles)})

(defui font-family-form [{:keys [dropzone queue header-height]}]
  (let [node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        font-families (use-subscribe [:assemble.resource.asset/font-families node-id])
        [font-family set-font-family] (uix/use-state "")]
    ($ :<>
       ($ Grid
          {:sx #js {:height header-height
                    :px 2}}
          ($ Typography
             {:variant "h4"
              :sx #js {:lineHeight (str header-height "px")}}
             "Add Fonts"))
       ($ dropzone-container
          {:dropzone dropzone
           :queue queue
           :asset-type :fonts}
          ($ Stack
             {:gap 1
              :onClick (fn [e]
                         (.stopPropagation e))
              :sx #js {:p 2
                       :pt 4}}
             ($ form-field
                {:label "Font family"}
                ($ Autocomplete
                   {:options (to-array font-families)
                    ;; Allow writing any value.
                    :freeSolo true
                    ;; Display the name in input when choosing with arrows.
                    :autoComplete true
                    ;; Select the first match with enter, if the search matches something.
                    :autoHighlight true
                    :inputValue font-family
                    :onInputChange (fn [_e value _reason] (set-font-family value))
                    :renderInput (fn [js-params]
                                   ($ TextField
                                      (spread-obj js-params
                                                  #js {:placeholder "Select or create a new font family"})))}))

             ($ Alert
                {:severity "info"
                 :icon ($ Icon "info")
                 :sx #js {".MuiAlert-icon" #js {:alignItems "center"}}}
                ;; FIXME:
                "Each time you upload font files, only add files that belong to a single font family. You can define the styles and weights for the files once they have been uploaded.")))
       ($ DialogActions
          ($ Button
             {:color "primary"
              :onClick #(rf/dispatch [:assemble.assets-page.upload-modal.db/close])}
             "Cancel")
          ($ Button
             {:variant "contained"
              :color "primary"
              :disabled (empty? font-family)
              :onClick #(rf/dispatch [:assemble.assets-page.upload-modal.db/set-font-family font-family])}
             "Next")))))
